/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/control-has-associated-label */
import { useEffect, useState } from 'react';
import { Row, Col, Form, InputGroup, Pagination, Alert } from 'react-bootstrap';
import { Lightbox } from 'react-modal-image';
import { useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faSearch,
  faList,
  faThLarge,
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/pro-solid-svg-icons';
import { faCircleNotch } from '@fortawesome/pro-regular-svg-icons';
import chunk from 'lodash/chunk';
import filter from 'lodash/filter';
import groupBy from 'lodash/groupBy';
import values from 'lodash/values';
import { InventoryTable } from './InventoryTable';
import { InventoryGridView } from './InventoryGridView';
import { useStorageInventory } from './queries';
import DraftPickList from './DraftPickList';
import { apiGet } from '../../../api';
import { useDraftPickList } from '../hooks/pickList';

const TABLE_PAGE_SIZE = 25;

function StorageInventory() {
  const [isGridView, setIsGridView] = useState(false);
  const [currentPageNumber, setCurrentPageNumber] = useState(1);
  const [currentRoomNumber, setCurrentRoomNumber] = useState('');
  const [currentShippingNumber, setCurrentShippingNumber] = useState('');
  const [currentLotName, setCurrentLotName] = useState('');
  const [roomList, setRoomList] = useState([]);
  const [shipmentNumberList, setShipmentNumberList] = useState([]);
  const [lotList, setLotList] = useState([]);
  const [showDelivered, setShowDelivered] = useState(false);
  const [search, setSearch] = useState('');
  const [totalPages, setTotalPages] = useState(1);
  const [currentPageInventoryItems, setCurrentPageInventoryItems] =
    useState(null);
  const [groupedItems, setGroupedItems] = useState(null);
  const [expandedRows, setExpandedRows] = useState([]);
  const [modalImageUrl, setModalImageUrl] = useState(null);
  const { data: allInventoryItems } = useStorageInventory();
  const [searchedInventoryItems, setSearchedInventoryItems] = useState([]);
  const { state } = useLocation();
  const {
    name: pickListName,
    itemsGrouped: draftPickListItemsGrouped,
    isItemInDraftPickList,
    handleAddToPickList,
    handleRemoveFromPickList,
    handleNameChange,
  } = useDraftPickList(state?.name, state?.items);

  const resetExpandedRows = () => {
    setExpandedRows([]);
  };

  const handleExpandedRows = (newRow) => {
    const currentRows = [...expandedRows];
    if (currentRows.includes(newRow)) {
      setExpandedRows(currentRows.filter((row) => row !== newRow));
    } else {
      currentRows.push(newRow);
      setExpandedRows(currentRows);
    }
  };

  const handleShowImage = (imageUrl) => {
    setModalImageUrl(imageUrl);
  };

  const filterSearch = () => {
    let inventories = filter(allInventoryItems, (inventoryItem) => {
      if (inventoryItem.ItemName.toLowerCase().includes(search.toLowerCase())) {
        return true;
      }

      if (
        inventoryItem.Comments &&
        inventoryItem.Comments.toLowerCase().includes(search.toLowerCase())
      ) {
        return true;
      }

      return false;
    });

    if (currentRoomNumber) {
      inventories = filter(
        inventories,
        (inventoryItem) => inventoryItem.RoomName === currentRoomNumber
      );
    }

    if (currentShippingNumber) {
      inventories = filter(
        inventories,
        (inventoryItem) =>
          inventoryItem.ShipmentNumber === Number(currentShippingNumber)
      );
    }

    if (currentLotName) {
      inventories = filter(
        inventories,
        (inventoryItem) =>
          inventoryItem.ili &&
          inventoryItem.ili[0] &&
          inventoryItem.ili[0].LotName === currentLotName
      );
    }

    inventories = filter(
      inventories,
      (inventoryItem) => inventoryItem.IsDelivered === showDelivered
    );
    inventories.forEach((thing) => console.log(thing.IsDelivered));
    return inventories;
  };

  useEffect(() => {
    if (searchedInventoryItems) {
      const pagedInventoryItems = chunk(
        searchedInventoryItems,
        TABLE_PAGE_SIZE
      );

      const pageIndex = currentPageNumber - 1;

      setTotalPages(pagedInventoryItems.length || 1);

      const currentPageItems = pagedInventoryItems[pageIndex];
      if (currentPageItems) {
        setCurrentPageInventoryItems(currentPageItems);
      } else {
        setCurrentPageInventoryItems([]);
      }
    }
  }, [currentPageNumber, searchedInventoryItems]);

  useEffect(() => {
    const currentSearchItems = filterSearch();
    setSearchedInventoryItems(currentSearchItems);
  }, [
    search,
    currentRoomNumber,
    currentShippingNumber,
    currentLotName,
    showDelivered,
  ]);

  useEffect(() => {
    if (allInventoryItems) {
      const currentSearchItems = filterSearch();
      setSearchedInventoryItems(currentSearchItems);

      const roomNames = allInventoryItems.map((item) => item.RoomName);
      const uniqueRoomNames = [...new Set(roomNames)];
      uniqueRoomNames.sort();
      setRoomList(uniqueRoomNames);

      const lotNames = allInventoryItems
        .filter(({ ili }) => ili?.length && ili[0] && ili[0].LotName)
        .map(({ ili }) => ili[0].LotName);
      const uniqueLotNames = [...new Set(lotNames)];
      uniqueLotNames.sort();
      setLotList(uniqueLotNames);

      const shipmentNumbers = allInventoryItems.map(
        (item) => item.ShipmentNumber
      );
      const uniqueShipmentNumbers = [...new Set(shipmentNumbers)];
      uniqueShipmentNumbers.sort();
      setShipmentNumberList(uniqueShipmentNumbers);
    }
  }, [allInventoryItems]);

  useEffect(() => {
    const pageItemsGrouped = values(
      groupBy(currentPageInventoryItems, (item) => {
        let result = item.InventoryItemID;
        if (item.GroupID !== null) {
          result = item.GroupID;
        }
        return result;
      })
    );

    setGroupedItems(pageItemsGrouped);
  }, [currentPageInventoryItems]);

  useEffect(() => {
    (async () => {
      const result = await apiGet('storage/inventory/picklists/all');
      console.log('pick lists result', await result.json());
    })();
  }, []);

  useEffect(() => {
    if (state?.success) {
      window.scrollTo(0, 0);
    }
  }, []);

  return (
    <div className="portal-inner has-tabs">
      {/* <Row> */}
      <Row>
        <Col xl={9}>
          <p>
            Below is a complete inventory of your items in storage with Gentle
            Giant. You can sort your items by shipment or room and click each
            item for more detail and description. This tool will let you submit
            a request to access your items at our warehouse or have them
            delivered. Click on the items below to create a "pick list" of
            requested items.
            <br />
            Click on the items below to create a “pick list” of requested items.
          </p>
        </Col>
        <Col xl={3}>
          <p>
            Create a name to identify the list of items you are requesting. You
            will be able to review your list again before submitting your
            request.
          </p>
        </Col>
      </Row>
      <Row>
        <Col xl={9}>
          {state?.success && (
            <Alert variant="success" transition={false}>
              Your pick list has been submitted. A Moving Consultant will be in
              touch to confirm the availability of your requested reservation.
            </Alert>
          )}

          <div className="info-box">
            <div className="info-header">
              <h3>
                Inventory{' '}
                <span className="fw-normal">
                  ({searchedInventoryItems?.length} items)
                </span>
              </h3>

              <Form>
                <Form.Group>
                  <InputGroup>
                    <Form.Control
                      type="text"
                      id="search-inventory"
                      onChange={(e) => setSearch(e.target.value)}
                    />
                    <InputGroup.Text>
                      <FontAwesomeIcon icon={faSearch} size="lg" />
                    </InputGroup.Text>
                  </InputGroup>
                </Form.Group>
              </Form>
            </div>
            <div className="info-content">
              <div className="d-flex justify-content-between align-items-center px-2 mb-3">
                <Form className="w-90">
                  <Form.Group as={Row} className="gx-2 align-items-center">
                    {/* TODO: Select all items
                      <Col sm={1}>
                        <Form.Check type="checkbox" />
                      </Col>
                    */}
                    {/* TODO: Filter by status
                      <Col>
                        <Form.Select>
                          <option value="">Status</option>
                        </Form.Select>
                      </Col>
                    */}
                    <Col>
                      <Form.Select
                        onChange={(e) => setCurrentRoomNumber(e.target.value)}
                      >
                        <option value="">Select Room</option>
                        {roomList &&
                          roomList.map((room) => (
                            <option value={room}>{room}</option>
                          ))}
                      </Form.Select>
                    </Col>
                    <Col>
                      <Form.Select
                        onChange={(e) =>
                          setCurrentShippingNumber(e.target.value)
                        }
                      >
                        <option value="">Select Shipment</option>
                        {shipmentNumberList &&
                          shipmentNumberList.map((num) => (
                            <option value={num}>{num}</option>
                          ))}
                      </Form.Select>
                    </Col>
                    <Col>
                      <Form.Select
                        onChange={(e) => setCurrentLotName(e.target.value)}
                      >
                        <option value="">Select Lot</option>
                        {lotList &&
                          lotList.map((name) => (
                            <option value={name} key={name}>
                              {name}
                            </option>
                          ))}
                      </Form.Select>
                    </Col>
                    <Col>
                      <Form.Check
                        type="checkbox"
                        label="Show Delivered Items"
                        onChange={() => setShowDelivered(!showDelivered)}
                      />
                    </Col>
                  </Form.Group>
                </Form>

                <div className="layout-toggle w-10">
                  <a
                    href="#"
                    onClick={(event) => {
                      setIsGridView(false);
                      event.preventDefault();
                    }}
                    className={`layout-list ${!isGridView ? 'active' : ''}`}
                  >
                    <FontAwesomeIcon icon={faList} size="lg" />
                  </a>
                  <a
                    href="#"
                    onClick={(event) => {
                      setIsGridView(true);
                      event.preventDefault();
                    }}
                    className={`layout-grid ${isGridView ? 'active' : ''}`}
                  >
                    <FontAwesomeIcon icon={faThLarge} size="lg" />
                  </a>
                </div>
              </div>

              {currentPageInventoryItems && groupedItems && !isGridView && (
                <InventoryTable
                  currentPageInventoryItems={groupedItems}
                  handleExpandedRows={handleExpandedRows}
                  handleAddToPickList={handleAddToPickList}
                  handleShowImage={handleShowImage}
                  isItemInDraftPickList={isItemInDraftPickList}
                  expandedRows={expandedRows}
                />
              )}

              {currentPageInventoryItems && isGridView && (
                <InventoryGridView
                  currentPageInventoryItems={currentPageInventoryItems}
                  handleAddToPickList={handleAddToPickList}
                  handleShowImage={handleShowImage}
                  isItemInDraftPickList={isItemInDraftPickList}
                />
              )}
              {!currentPageInventoryItems && (
                <div className="text-center py-5">
                  <FontAwesomeIcon
                    icon={faCircleNotch}
                    spin
                    size="3x"
                    style={{ color: '#953263' }}
                  />
                </div>
              )}

              <div className="d-flex justify-content-between align-items-center mt-4">
                <Pagination>
                  <li className="page-item disabled">
                    <span className="page-link" disabled>
                      <span aria-hidden="true">
                        <FontAwesomeIcon icon={faChevronLeft} />
                      </span>
                      <span className="visually-hidden">Previous</span>
                    </span>
                  </li>
                  {[...Array(Math.min(totalPages, 10)).keys()].map(
                    (pageIndex) => {
                      const pageNumber = pageIndex + 1;
                      return (
                        <Pagination.Item
                          key={pageIndex}
                          active={pageNumber === currentPageNumber}
                          onClick={() => {
                            setCurrentPageNumber(pageNumber);
                            resetExpandedRows();
                          }}
                        >
                          {pageNumber}
                        </Pagination.Item>
                      );
                    }
                  )}
                  <li className="page-item">
                    <a
                      className="page-link"
                      role="button"
                      tabIndex="0"
                      href="#"
                    >
                      <span aria-hidden="true">
                        <FontAwesomeIcon icon={faChevronRight} />
                      </span>
                      <span className="visually-hidden">Next</span>
                    </a>
                  </li>
                </Pagination>
                <div className="d-flex align-items-center">
                  {/* TODO: items per page
                    <Form.Group className="d-flex align-items-center">
                      <Form.Select>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                      </Form.Select>
                      <Form.Label className="flex-shrink-0 fw-normal ms-2 mb-0">
                        items per page
                      </Form.Label>
                    </Form.Group>
                    <div className="item-count ms-4">1-22 of 22 items</div>
                  */}
                </div>
              </div>
            </div>
          </div>
        </Col>
        <Col xl={3}>
          <DraftPickList
            draftItems={draftPickListItemsGrouped}
            name={pickListName}
            handleRemoveFromPickList={handleRemoveFromPickList}
            handleNameChange={handleNameChange}
          />
        </Col>
      </Row>
      {modalImageUrl && (
        <div id="storage-portal-lightbox">
          <Lightbox
            small={modalImageUrl}
            large={modalImageUrl}
            hideDownload
            onClose={() => {
              setModalImageUrl(null);
            }}
          />
        </div>
      )}
    </div>
  );
}

export default StorageInventory;
